import React from 'react';
import cs from 'classnames';
import { Flex } from 'shared/components/display';
import ToggleSwitch from 'shared/components/atoms/ToggleSwitch';

import { COLLECTION_COPY } from 'shared/config/copy';
import { Collection } from 'shared/typings/collections';

import styles from './styles';

interface Props {
  toggleCollectionPrivacy: () => void;
  collection: Collection;
}
const CreatorCollectionsActions: React.FC<Props> = ({ toggleCollectionPrivacy, collection }) => {
  return (
    <Flex css={styles} className={cs('creator-collections-actions')}>
      {!collection.isDefault && (
        <ToggleSwitch
          onClick={toggleCollectionPrivacy}
          fieldName="collection-privacy-toggle"
          label={COLLECTION_COPY.LABEL_COLLECTION_TOGGLE_PRIVACY}
          toggledOn={collection.publicAccess}
          className="creator-collections-actions__toggle"
        />
      )}
    </Flex>
  );
};

export default CreatorCollectionsActions;
